import { Options } from 'models'
import { useFetchList } from 'store'

import styles from './PersonalAreaController.module.sass'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import { useLocation } from 'react-router-dom'
import useSession from 'hooks/useSession'
import { useMemo } from 'react'
import useTermSearch from 'hooks/useTermSearch'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import TextSearchInput from 'components/TextSearchInput/TextSearchInput'
import { useDeepCompareEffect } from 'react-use'

const ManagementOpinionFilters = (props) => {
	const { className, data, handleDataCollection } = props

	const { i18n } = useGlobal()
	const { user: sessionUser } = useSession()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)

	const {
		contents: [trustManagers],
	} = useFetchList(
		['/metadata/trust_managers'],
		[Options.fromSimpleObjectJSON]
	)

	const sortOptions = [
		{
			value: 'date,asc',
			text: i18n`Date, asc.`,
		},
		{
			value: 'date,desc',
			text: i18n`Date, desc.`,
		},
	]

	const trustManagersFilter = useMemo(
		() =>
			Array.isArray(trustManagers)
				? [
						{
							value: 'user',
							text: i18n`My opinion requests`,
						},
						{
							value: '',
							text: i18n`All`,
						},
						...trustManagers.filter(
							({ value }) => value !== sessionUser.legacyId
						),
				  ]
				: [],
		[i18n, sessionUser.legacyId, trustManagers]
	)

	const selectedTrustManager = queryParams.claimsManagerTrust
		? trustManagersFilter.find(
				({ value }) =>
					queryParams.claimsManagerTrust.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const { searchMatches, onSearch, query } = useTermSearch(data, [
		'submittedMedicalRequest',
		'processId',
	])

	useDeepCompareEffect(() => {
		handleDataCollection(
			{
				matches: searchMatches,
			},
			{
				query,
			}
		)
	}, [searchMatches, query])

	const selectedSort = queryParams.sort
		? sortOptions.find(
				({ value }) =>
					queryParams.sort.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	return (
		<HStack justify='space-between'>
			<HStack className={className} gap='small'>
				<VStack>
					<small>
						<strong>{i18n`Management opinions`}</strong>
					</small>
					<small className='ellipsis'>{i18n`Order by`}:</small>
				</VStack>

				<div>
					<Dropdown
						className={styles['options-entry']}
						name='sort'
						value={
							selectedSort
								? selectedSort.value
								: sortOptions[0].value
						}
						options={sortOptions}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								sort: e.target.value,
							})
						}}
					/>
				</div>

				<HStack
					className={styles['search-input']}
					align='center'
					justify='flex-start'
					wrap='nowrap'
					gap='xsmall'
				>
					<small>
						<strong>{i18n`Search`}</strong>
					</small>
					<TextSearchInput
						placeholder={i18n`Search by terms`}
						className={styles['search-bar']}
						onKeyUp={(e) => {
							return onSearch(e)
						}}
						onChange={(e) => {
							return onSearch(e)
						}}
					/>
				</HStack>
				{trustManagersFilter.length ? (
					<Dropdown
						className={styles['restrict-dropdown']}
						placeholder={i18n`See management opinions`}
						name='restrict'
						searchable
						value={
							selectedTrustManager
								? selectedTrustManager.value
								: trustManagersFilter[1].value
						}
						options={trustManagersFilter}
						onChange={(e) => {
							setQueryParams({
								claimsManagerTrust: e.target.value,
							})
						}}
					/>
				) : null}
			</HStack>
		</HStack>
	)
}

export default ManagementOpinionFilters
